import { hasItems } from "./arrays";
import { hasValue } from "./strings";
import * as logger from "common/logger";

export const OPERATOR = {
  EQUAL: "EQUAL",
  NOT_EQUAL: "NOT_EQUAL",
  GREATER_THAN: "GREATER_THAN",
  GREATER_THAN_OR_EQUAL: "GREATER_THAN_OR_EQUAL",
  LESS_THAN: "LESS_THAN",
  LESS_THAN_OR_EQUAL: "LESS_THAN_OR_EQUAL",
  IN: "IN",
  NOT_IN: "NOT_IN",
  CONTAINS: "CONTAINS",
  NOT_CONTAINS: "NOT_CONTAINS",
  STARTS_WITH: "STARTS_WITH",
  NOT_STARTS_WITH: "NOT_STARTS_WITH",
  ENDS_WITH: "ENDS_WITH",
  NOT_ENDS_WITH: "NOT_ENDS_WITH",
};

const logError = (text, context, error) => {
  if (!hasValue(context)) {
    context = "unspecified calling context";
  }
  logger.error(
    `${text} applying filter for ${context}${
      error ? `:\n${error.message}` : ""
    }`
  );
};

const applySingleFilter = (filter, objArray, errorContext) => {
  if (typeof filter !== "object" || filter.key == null) {
    logError("Invalid filter", errorContext);
    return objArray;
  }

  const { key, operator = OPERATOR.EQUAL, value: expected } = filter;

  try {
    return objArray.filter((item) => {
      const value = item[key];

      switch (operator) {
        case OPERATOR.EQUAL:
          return value === expected;
        case OPERATOR.NOT_EQUAL:
          return value !== expected;
        case OPERATOR.GREATER_THAN:
          return value > expected;
        case OPERATOR.GREATER_THAN_OR_EQUAL:
          return value >= expected;
        case OPERATOR.LESS_THAN:
          return value < expected;
        case OPERATOR.LESS_THAN_OR_EQUAL:
          return value <= expected;
        case OPERATOR.IN:
          return Array.isArray(expected) && expected.includes(value);
        case OPERATOR.NOT_IN:
          return Array.isArray(expected) && !expected.includes(value);
        case OPERATOR.CONTAINS:
          return value != null && String(value).includes(String(expected));
        case OPERATOR.NOT_CONTAINS:
          return value == null || !String(value).includes(String(expected));
        case OPERATOR.STARTS_WITH:
          return value != null && String(value).startsWith(String(expected));
        case OPERATOR.NOT_STARTS_WITH:
          return value == null || !String(value).startsWith(String(expected));
        case OPERATOR.ENDS_WITH:
          return value != null && String(value).endsWith(String(expected));
        case OPERATOR.NOT_ENDS_WITH:
          return value == null || !String(value).endsWith(String(expected));
        default:
          logError(`Unrecognised operator '${operator}'`, errorContext);
          return true;
      }
    });
  } catch (error) {
    logError("Error", errorContext, error);
    return [];
  }
};

export const apply = (filters, objArray, errorContext) => {
  if (!filters) {
    return objArray ?? [];
  }

  if (!Array.isArray(filters)) {
    logError("Missing or invalid filters", errorContext);
    return objArray ?? [];
  }

  if (!hasItems(objArray)) {
    return [];
  }

  if (filters.length === 0) {
    return objArray;
  }

  return filters.reduce(
    (acc, curr) => applySingleFilter(curr, acc, errorContext),
    objArray
  );
};
